'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */
var ColidoLayoutView = require('base/Colido.LayoutView');
var UploadComponent = require('modules/settings/views/partials/profile/upload.js');
var template = require('modules/settings/templates/partials/profile/picture.hbs');

var ProfilePictureView = ColidoLayoutView.extend({
    template: template,
    wrapItem: false,

    imageUploadComponent: null,
    imageId: null,
    imageUrl: null,
    imageCrop: true,
    imageStream: true,

    // stream
    video: null,
    stream: null,
    videoObj: null,

    ui: {
        'imagePreviewContent': '.image-preview-content',
        'imageDelete': '[data-action="delete-image"]',
        'imageUploadTrigger': '[data-action="trigger-upload"]',
        'imageId': '[name="imageId"]',
        'imageUploadComponentRegion': '.profile-picture-upload-region',

        // stream
        'profileTakePictureVideo': '.profile-take-picture-video',
        'profileTakePictureCanvas': '.profile-take-picture-canvas',
        'profilePictureTakePhoto': '[data-action="take-profile-picture"]',
        'profilePictureTakePhotoSnapshot': '[data-action="take-profile-picture-snapshot"]',
        'profilePictureTakePhotoSnapshotCancel': '[data-action="take-profile-picture-snapshot-cancel"]',
        'profilePictureTakePhotoSnapshotSubmit': '[data-action="take-profile-picture-snapshot-submit"]',
        'profilePictureTakePhotoSnapshotRedo': '[data-action="take-profile-picture-snapshot-redo"]',
    },

    events: {
        'click @ui.imageDelete': 'onImageDelete',

        // stream
        'click @ui.profilePictureTakePhoto': 'onProfilePictureTakePhoto',
        'click @ui.profilePictureTakePhotoSnapshot': 'onProfilePictureTakePhotoSnapshot',
        'click @ui.profilePictureTakePhotoSnapshotCancel': 'onProfilePictureTakePhotoSnapshotCancel',
        'click @ui.profilePictureTakePhotoSnapshotSubmit': 'onProfilePictureTakePhotoSnapshotSubmit',
        'click @ui.profilePictureTakePhotoSnapshotRedo': 'onProfilePictureTakePhoto',
    },

    regions: {
        'imageUploadComponentRegion': '.image-upload-region',
    },

    childEvents: {
        'upload:state:finished': 'onImageChanged',
    },

    modelEvents: {
        'change sync': 'render',
    },

    onRender: function() {
        this.imageUploadComponent = new UploadComponent({});
        this.imageUploadComponentRegion.show(this.imageUploadComponent);

        if (this.model.get('profilePictureUrl')) {
            this.onImageChanged(null, this.model.get('profilePictureUrl'));
        } else {
            this._setImage(null);
        }

        if (this.imageStream) {
            if (!this._canUseStream()) {
                // if the browser doesn't supports streams, hide all stream-buttons
                this.ui.profilePictureTakePhotoSnapshotSubmit.remove();
                this.ui.profilePictureTakePhotoSnapshotCancel.remove();
                this.ui.profilePictureTakePhotoSnapshotRedo.remove();
                this.ui.profilePictureTakePhoto.remove();
            } else {
                // if there was already an stream running, delete it
                this._deleteStream();
            }
        }

        this.ui.imageUploadTrigger.attr('for', 'input-file-upload-' + this.imageUploadComponent.fileSelectView.cid);
    },

    onImageDelete: function(event) {
        event.preventDefault();

        this._setImage(false);
        this.triggerMethod('profile:changed');
    },

    onProfilePictureTakePhotoSnapshotSubmit: function(event) {
        event.preventDefault();

        this.ui.profilePictureTakePhotoSnapshotSubmit.hide();
        var canvas = this.ui.profileTakePictureCanvas.get(0);
        var png = canvas.toDataURL();

        $.ajax({
            url: App.getApiUrl('/assets'),
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                type: 'base64',
                data: png,
            }),
            success: function (data) {
                this.onImageChanged(null, data);
                this.triggerMethod('profile:changed');
            }.bind(this),
            error: function (data) {
                this._setImage(this.imageId, this.imageUrl); // reset to the stored one
            }.bind(this),
        });

        this._deleteStream();
    },

    onProfilePictureTakePhotoSnapshotCancel: function(event) {
        event.preventDefault();

        this._setImage(this.imageId, this.imageUrl);
        this._deleteStream();
    },

    onProfilePictureTakePhotoSnapshot: function(event) {
        event.preventDefault();

        this._hideAll();
        this.ui.profilePictureTakePhotoSnapshotSubmit.show();
        this.ui.profilePictureTakePhotoSnapshotCancel.show();
        this.ui.profilePictureTakePhotoSnapshotRedo.show();
        this.ui.profileTakePictureCanvas.show();

        var canvas = this.ui.profileTakePictureCanvas.get(0);
        canvas.width = this.video.videoWidth;
        canvas.height = this.video.videoHeight;

        // TODO: it would be great, if the preview were also as 1:1, not in the shape of the webcam

        var context = canvas.getContext('2d');
        context.drawImage(this.video, 0, 0, this.video.videoWidth, this.video.videoHeight);
    },

    onProfilePictureTakePhoto: function(event) {
        event.preventDefault();

        this._hideAll();
        this.ui.profileTakePictureVideo.show();
        this.ui.profilePictureTakePhotoSnapshotCancel.show();
        this.ui.profilePictureTakePhotoSnapshot.show();

        this._startStream();
    },

    onImageChanged: function(event, data) {
        // TODO: the resolution may have to be dynamic
        var image = data.baseUrl + '300x300/' + data.fileName;

        this._setImage(data.id, image);
    },

    /**
     * Hides all Buttons.
     * @private
     */
    _hideAll: function() {
        this.ui.profileTakePictureVideo.hide();
        this.ui.profilePictureTakePhotoSnapshotCancel.hide();
        this.ui.profilePictureTakePhotoSnapshot.hide();
        this.ui.profileTakePictureCanvas.hide();
        this.ui.profilePictureTakePhoto.hide();
        this.ui.profilePictureTakePhotoSnapshotSubmit.hide();
        this.ui.profilePictureTakePhotoSnapshotRedo.hide();

        this.ui.imagePreviewContent.hide();
        this.ui.imageUploadComponentRegion.hide();
        this.ui.imageUploadTrigger.hide();
        this.ui.imageDelete.hide();
    },

    /**
     * @param id number id des assets
     * @param url string vollständige url zum asset
     * @private
     */
    _setImage: function(id, url) {
        this._hideAll();
        this.ui.imageUploadComponentRegion.show();
        this.ui.profilePictureTakePhoto.show();

        if (id && url) {
            this.ui.imageUploadTrigger.hide();
            this.ui.imageDelete.show();

            this.ui.imagePreviewContent.find('img').remove();
            this.ui.imageId.val(id);
            if (this.imageCrop) {
                this.ui.imagePreviewContent.css({
                    'background-image': 'url(' + url + ')',
                }).show();
            } else {
                var img = $('<img>').attr('src', url);
                this.ui.imagePreviewContent.show().append(img);
            }
            this.imageId = id;
            this.imageUrl = url;
        } else {
            this.ui.imageUploadTrigger.show();
            this.ui.imageDelete.hide();

            this.ui.imageId.val(-1);
            this.ui.imagePreviewContent.css({
                'background-image': 'none',
            }).hide();
            this.imageId = null;
            this.imageUrl = null;
        }
    },

    /**
     * Return true, if the Browser supports getUserMedia.
     * @returns {boolean}
     * @private
     */
    _canUseStream: function() {
        return (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia) ? false && location.protocol === 'https:' : false;
    },

    /**
     * Delete the stream, if there was one.
     * @private
     */
    _deleteStream: function() {
        if (_.isObject(this.video)){
            this.video.pause();
            this.video.src = '';

            if (this.stream) {
                try{
                    // some browsers need to undo tracks to disable the video
                    this.stream.getTracks()[0].stop();
                }catch(error) {
                    // and some other just need tu use stop on the stream
                    if (this.stream.stop){
                        this.stream.stop();
                    }
                }
            }
        }
        this.video = null;
        this.videoObj = null;
    },

    /**
     * Starts the videostream.
     * @private
     */
    _startStream: function() {
        if (_.isNull(this.video)) {
            // just set it to std. we don't need any prefixes. they are all the same stuff
            navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || null;
            window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL || null;

            this.video = this.ui.profileTakePictureVideo.get(0); // get the video-tag
            this.videoObj = {'video': true,};

            navigator.getUserMedia(this.videoObj, function(stream) {
                if (window.URL) {
                    // WebKit and Firefox - Style
                    this.video.src = window.URL.createObjectURL(stream);
                } else {
                    // Std - Style
                    this.video.src = stream;
                }

                this.video.play();
                this.stream = stream;
            }.bind(this), function(error) {
                this.onProfilePictureTakePhotoSnapshotCancel(new CustomEvent(''));
                console.log('Video capture error: ', error.code); // TODO: show proper error msg
            }.bind(this));
        }
    },
});

module.exports = ProfilePictureView;